import { render, staticRenderFns } from "./data-inspection.vue?vue&type=template&id=514c8c36&scoped=true"
import script from "./data-inspection.vue?vue&type=script&lang=js"
export * from "./data-inspection.vue?vue&type=script&lang=js"
import style0 from "./data-inspection.vue?vue&type=style&index=0&id=514c8c36&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "514c8c36",
  null
  
)

export default component.exports